import Env from "../base/env";
import Component from "gia/Component";
import gsap from "gsap";
import easesCustom from "../fx/CustomEases";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class Module extends Component {
  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.quote = this.DOM.view.querySelector("blockquote div");
    this.DOM.author = this.DOM.view.querySelector("blockquote p");
    console.log(this.DOM);
    //! VARS
    this.FX = {};

    this.FX.quote = new SplitText(this.DOM.quote, {
      type: "lines",
      linesClass: "tw-overflow-hidden",
      lineThreshold: 0.1,
    });
    this.FX.quoteChildren = new SplitText(this.DOM.quote, {
      type: "lines",
      linesClass: "tw-overflow-hidden lg:tw-mb-[-10px]",
      lineThreshold: 0.1,
    });
    //! Fns
    gsap.delayedCall(0.5, () => {
      this._fx();
    });
  }

  _fx() {
    this.animate();
    this.reveal();
  }

  animate() {
    this.animation = gsap.timeline();

    this.animation.add([
      gsap.fromTo(
        this.FX.quote.lines,
        {
          y: 150,
        },
        {
          y: 0,
          ease: "quint.out",
          duration: 1,
          stagger: 0.1,
        }
      ),
      gsap.fromTo(
        this.DOM.author,
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1,
          ease: easesCustom.cubic,
          duration: 1,
        }
      ),
    ]);
  }

  reveal() {
    const offsetStart = Env.mobileCSS ? "top 80%" : "top 50%";
    this.st = ScrollTrigger.create({
      animation: this.animation,
      trigger: this.DOM.view,
      start: offsetStart,
    });
  }

  unmount() {
    this.st.kill(true);
  }
}
